import PropTypes from 'prop-types'

import { Span } from 'components'

type Props = ISpan & {
  yearBuilt: number | string
}

export const YearBuilt: React.FC<Props> = ({ yearBuilt, ...style }) => (
  <Span {...style}>{`Built ${yearBuilt}`}</Span>
)
YearBuilt.propTypes = {
  yearBuilt: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
}
